import { rmlOpts } from "../utils/rmlOpts.js";
import { urlParam } from "../utils/urlParam.js";
const ID_NONE = -2;
const ID_LAST_QUERIED = -3;
function adjustLinks(df = getDefaultFolder(false)) {
    if (process.env.PLUGIN_CTX === "pro") {
    /* Silence is golden... Until you have PRO Version! */ }
}
function readDefaultFolderSetting() {
    const raw = rmlOpts.others.defaultFolder;
    // PHP returns "" when the option is unset — not the same as user-picked ID_NONE (-2).
    if (raw === "" || raw === undefined) {
        return 0;
    }
    return +raw;
}
function getDefaultFolder(resolve = true) {
    let id;
    if (process.env.PLUGIN_CTX === "pro") {
    /* Silence is golden... Until you have PRO Version! */ }
    // Higher priority list mode query parameter
    id = urlParam("rml_folder") || id;
    // Resolve
    switch(id){
        case ID_LAST_QUERIED:
            return +rmlOpts.others.lastQueried;
        default:
            return id;
    }
}
function applyDefaultFolderUserSettingsSaved(id, response, data) {
    if (process.env.PLUGIN_CTX === "pro") {
    /* Silence is golden... Until you have PRO Version! */ }
}
function onTreeFolderSelected(id) {
    if (process.env.PLUGIN_CTX === "pro") {
    /* Silence is golden... Until you have PRO Version! */ }
}
export { ID_NONE, adjustLinks, applyDefaultFolderUserSettingsSaved, getDefaultFolder, onTreeFolderSelected };
